/**
 * Auth Routes Constants
 */

export const AUTH_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
} as const;
